module.exports = __webpack_public_path__ + "static/media/mail-accent-light.e7c45aa2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail-accent-light.svg
// module id = 682
// module chunks = 0